var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{class:_vm.moving ? 'isMoving' : '',attrs:{"elevation":_vm.moving ? 15 : 4,"width":_vm.width,"height":_vm.height}},[_c('Map',{attrs:{"vessels":_vm.vessels,"resizing":_vm.resized}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }